<template>
    <div>
        <div class="header">
            <el-select size="mini" v-model="hide" @change="hideChange">
                <el-option :label="$t('lang.onAndOf.all')" :value="undefined"></el-option>
                <el-option :label="$t('lang.terminalList.hiddenTerminal')" :value="1"></el-option>
                <el-option :label="$t('lang.terminalList.nohiddenTerminal')" :value="0"></el-option>
            </el-select>
            <el-select size="mini" v-model="time">
                <el-option :label="$t('lang.devicelist.batch')" :value="0"></el-option>
                <el-option :label="$t('lang.devicelist.L5Nrefresh')" :value="5"></el-option>
                <el-option :label="$t('lang.devicelist.L10Nrefresh')" :value="10"></el-option>
                <el-option :label="$t('lang.devicelist.L20Nrefresh')" :value="20"></el-option>
                <el-option :label="$t('lang.devicelist.L60Nrefresh')" :value="60"></el-option>
            </el-select>
        </div>
        <div class="content">
            <TableComponent :btnFixed="true" :Columns="Columns" :ColuumnsButton="ColuumnsButton" :data="list"
                :ColuumnsButtonWidth="280" :seek="seek" @sortChange="sortChange" @showPage="showPage"
                @editDetail="editDetail" @showDetail="showDetail" @copyUrl="copyUrl" @deleteDetail="deleteDetail">
                <span slot="slot" slot-scope="scope" style="color:#409eff;font-size:15px;">{{ scope.scope.$index }}</span>
                <span slot="nameSlot" slot-scope="scope" class="name_content">
                    {{ scope.scope.row.name }}
                </span>
                <span slot="customColumn" slot-scope="scope" style="color:#409eff;font-size:15px;">
                    <el-tag v-if="scope.scope.row.state == 0" type="success">{{ $t('lang.devicelist.connected') }}</el-tag>
                    <el-tag v-else type="danger">{{ $t('lang.devicelist.not') }}</el-tag>
                </span>
                <span slot="typeslot" slot-scope="scope">
                    {{ scope.scope.row.ts | formatTime }}
                </span>
            </TableComponent>
        </div>
        <div class="footer">
            <Pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
                @CurrentChanges="CurrentChanges"></Pagination>
        </div>
        <el-dialog :title="$t('lang.openvpn.edit')" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
            <el-form :model="editContent" :rules="rule" label-width="100px" ref="editContent">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="editContent.name" size="mini" style="width:190px;"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-select v-model="editContent.type" size="mini" clearable>
                        <el-option label="网络摄像头" value="网络摄像头"></el-option>
                        <el-option label="模拟摄像头" value="模拟摄像头"></el-option>
                        <el-option label="NVR/DVR" value="NVR/DVR"></el-option>
                        <el-option label="工控机服务器" value="工控机服务器"></el-option>
                        <el-option label="PC服务器" value="PC服务器"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="edit_confrim">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import TableComponent from '@/components/TableComponent/index'
import { PublicComponent } from "../../../mixins/common"
import { Columns, ColuumnsButton } from './TableConfig'
import { getCameraList, editCamera, deleteCamera } from "@/api/terminalList"
import Pagination from "@/components/pagination"
export default {
    name: "",
    components: {
        TableComponent,
        Pagination
    },
    mixins: [PublicComponent],
    data() {
        return {
            hide: 0,
            time: 10,
            Columns,
            ColuumnsButton,
            list: [],
            seek: {
                subdomain: "",
                sn: "",
                name: "",
                type: "",
                ip: "",
                state: ""
            },
            timmer: null,
            sortNum: undefined,
            dialogVisible: false,
            editContent: {
                name: "",
                type: "",
                id: ""
            },
            rule: {
                name: [
                    { required: true, message: this.$t('lang.terminalList.name'), trigger: 'blur' },
                ],
            },
        };
    },
    mounted() {
        this.queryKeyword()
        if (!this.timmer) {
            this.timmer = setInterval(() => {
                this.queryKeyword()
            }, this.time * 1000);
        }
    },
    // 销毁时
    beforeDestroy() {
        clearInterval(this.timmer)
    },
    methods: {
        queryKeyword() {
            getCameraList({
                hide: this.hide,
                current: this.offset,
                size: this.limit,
                sortNum: this.sortNum,
                ...this.seek,
            }).then(res => {
                this.limit = res.data.data.limit;
                this.total = res.data.data.total;
                this.list = res.data.data.list;
                this.list.unshift({})
            })
        },
        hideChange(e) {
            this.queryKeyword()
        },
        sortChange(e) {
            if (!e.order) return this.sortNum = undefined
            if (e.order == "ascending") {
                switch (e.property) {
                    case "subdomain":
                        this.sortNum = 13
                        break;
                    case "sn":
                        this.sortNum = 1
                        break
                    case 'name':
                        this.sortNum = 3
                        break
                    case 'type':
                        this.sortNum = 11
                        break;
                    case 'ip':
                        this.sortNum = 5
                        break;
                    case 'ts':
                        this.sortNum = 9
                        break;
                }
            } else {
                switch (e.property) {
                    case "subdomain":
                        this.sortNum = 14
                        break;
                    case "sn":
                        this.sortNum = 2
                        break;
                    case 'name':
                        this.sortNum = 4
                        break
                    case 'type':
                        this.sortNum = 12
                        break;
                    case 'ip':
                        this.sortNum = 6
                        break;
                    case 'ts':
                        this.sortNum = 10
                        break;
                }
            }
        },
        showPage(e) {
            // 获取当前host
            let host = window.location.hostname
            let port = e.port
            // 跳转
            // window.open(`http://${host}:${port}/doc/page/login.asp?_` + Date.now())
            window.open(`http://${host}:${port}`)
        },
        copyUrl(e) {
            let host = window.location.hostname
            let port = e.port
            // let url = `http://${host}:${port}/doc/page/login.asp?_` + Date.now()
            let url = `http://${host}:${port}`
            try {
                navigator.clipboard.writeText(url).then(() => {
                    this.$message({
                        message: this.$t('lang.terminalList.copySuccess'),
                        type: 'success'
                    });
                }).catch(() => {
                    this.$message({
                        message: this.$t('lang.terminalList.copyFail'),
                        type: 'error'
                    });
                })
            } catch (error) {
                let textarea = document.createElement('textarea')
                textarea.value = url
                textarea.style.position = 'fixed'
                textarea.style.top = 0
                textarea.style.left = 0
                textarea.style.opacity = 0
                document.body.appendChild(textarea)
                textarea.focus()
                textarea.select()
                try {
                    document.execCommand('copy')
                    this.$message({
                        message: this.$t('lang.terminalList.copySuccess'),
                        type: 'success'
                    });
                } catch (error) {
                    this.$message({
                        message: this.$t('lang.terminalList.copyFail'),
                        type: 'error'
                    });
                } finally {
                    document.body.removeChild(textarea)
                }
            }
        },
        deleteDetail(e) {
            this.$confirm(this.$t('lang.terminalList.deleteDetail'), this.$t('lang.terminalList.tip'), {
                confirmButtonText: this.$t('lang.terminalList.Confirm'),
                cancelButtonText: this.$t('lang.terminalList.Cancel'),
                type: 'warning'
            }).then(async () => {
                await deleteCamera({
                    id: e.id,
                    did: e.did,
                    sn: e.sn,
                    subdomain: e.subdomain
                })
                this.queryKeyword()
            })
        },
        editDetail(e) {
            this.editContent.name = e.name
            this.editContent.type = e.type
            this.editContent.id = e.id
            this.dialogVisible = true
        },
        showDetail(e) {
            this.$confirm(this.$t('lang.terminalList.showDetail'), this.$t('lang.terminalList.tip'), {
                confirmButtonText: this.$t('lang.terminalList.Confirm'),
                cancelButtonText: this.$t('lang.terminalList.Cancel'),
                type: 'warning'
            }).then(async () => {
                await editCamera({
                    id: e.id,
                    hide: e.hide == 0 ? 1 : 0
                })
                this.queryKeyword()
            })
        },
        edit_confrim() {
            this.$refs['editContent'].validate(async (valid) => {
                if (valid) {
                    await editCamera({
                        id: this.editContent.id,
                        name: this.editContent.name,
                        type: this.editContent.type
                    })
                    this.queryKeyword()
                    this.dialogVisible = false
                } else {
                    return false;
                }
            });
        }
    },
    filters: {
        //格式化时间戳
        formatTime(value) {
            if (value) {
                return new Date(value).toLocaleString()
            } else {
                return ''
            }
        }
    },
    watch: {
        time: {
            handler(val) {
                clearInterval(this.timmer)
                if (val) {
                    this.timmer = setInterval(() => {
                        this.queryKeyword()
                    }, val * 1000);
                }
            },
        },
        sortNum: {
            handler(val) {
                this.queryKeyword()
            }
        }
    }
};
</script>
<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.content {
    width: 100%;
    margin-top: .5rem;
}

.footer {
    margin: 0 auto;
}

.name_content {
    display: inline-block;
    white-space: pre-wrap;
}
</style>